import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const CustomTooltip = ({ mensaje, children, alineado = "bottom", tamano = "1rem", offsetX = 5}) => {
  return (
    <Tooltip
      title={<span style={{ fontSize: tamano }}>{mensaje}</span>} 
      placement={alineado} 
      arrow
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, offsetX], 
            },
          },
        ],
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
